import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import {SlideDown} from 'react-slidedown'
import * as searchActions from 'redux/modules/search'
import {
  LinkIcon
} from '../'
import Styles from './ScreenedCompaniesList.css'

@connect(
  state => ({
    results: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple: true})
export default class ScreenedCompaniesList extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    results: PropTypes.object,
  }
  constructor(props){
    super(props)
    this.state = {
      viewMore_is_co: false,
      viewMore_is_og: false,
      viewMore_is_f15: false,
      viewMore_is_ut: false,
      viewMore_is_fossil_bank: false,
      viewMore_is_fossil_insure: false,
      viewMore_is_po_producer: false,
      viewMore_is_po_financier: false,
      viewMore_is_po_consumer: false,
      viewMore_is_gm: false,
      viewMore_is_gr: false,
      viewMore_is_pp: false,
      viewMore_is_borders: false,
      viewMore_is_pff_high: false,
      viewMore_is_pff_extreme: false,
      viewMore_is_mmc: false,
      viewMore_is_nw: false,
      viewMore_is_cm: false,
      viewMore_is_to: false,
      viewMore_is_tm: false,
      is_co: [],
      is_og: [],
      is_f15: [],
      is_ut: [],
      is_fossil_bank: [],
      is_fossil_insure: [],
      is_po_producer: [],
      is_po_financier: [],
      is_po_consumer: [],
      is_gm: [],
      is_gr: [],
      is_pp: [],
      is_borders: [],
      is_pff_high: [],
      is_pff_extreme: [],
      is_mmc: [],
      is_nw: [],
      is_cm: [],
      is_to: [],
      is_tm: []
    }
  }

  componentWillReceiveProps(props){
    if (props.results && props.results.result) {
      const companies = []
      props.results.result.map((el)=>{
        if (el[props.screen]) companies.push(el)
        return false
      })
      if (companies.length <= 0) {
        return
      }
      const _sorter = (a, b)=>{
        const lbl = 'short_name'
        const a_s = a[lbl].toLowerCase()
        const b_s = b[lbl].toLowerCase()
        return a_s.localeCompare(b_s)
      }
      const newState = {}
      newState[props.screen] = companies.sort(_sorter)
      // console.log('\n\n\nlorem here newState')
      // console.log(newState)
      // console.log('lorem here this.state')
      // console.log(this.state)
      // console.log('lorem here this.props.screen')
      // console.log(this.props.screen)
      this.setState(newState)
    }
  }

  clickViewMore = () =>{
    if (this.state[this.props.screen].length <= 0){
      this.props.companies(this.props.screen)
    }
    const newState = {}
    newState['viewMore_' + this.props.screen] = !this.state['viewMore_' + this.props.screen]
    this.setState(newState)
  }

  render() {
    const label = (!this.state['viewMore_' + this.props.screen] ) ? 'View companies' : 'View less'

    return (
      <div styleName='main-wrap'>

        <div styleName='company-table-wrapper'>
          <button
            styleName="company-table-button"
            onClick={ this.clickViewMore }
            title={label}
          >
            {label}
            <LinkIcon
              faclass={this.state['viewMore_' + this.props.screen] ? 'fa-angle-up' : 'fa-angle-down'}
            />
          </button>
          <SlideDown>
            {
              this.state['viewMore_' + this.props.screen] ?
                (
                  <div>
                    {
                      this.state[this.props.screen] && this.state[this.props.screen].length>0 ?
                        (
                          <div>
                            <div styleName='table-count'>
                              {this.state[this.props.screen].length.toLocaleString()} companies flagged
                            </div>
                            <table styleName='t-table'>
                              <thead>
                                <tr>
                                  <th>Company</th>
                                  <th>Symbol</th>
                                  <th>Legal name</th>
                                </tr>
                              </thead>
                              <tbody>
                                { this.state[this.props.screen].map((c, i)=>{
                                  return (
                                    <tr key={'to_'+i}>
                                      <td>{c.short_name}</td>
                                      <td>{c.primary_symbol}</td>
                                      <td>{c.legal_name}</td>
                                    </tr>
                                  )
                                }) }
                              </tbody>
                            </table>
                          </div>
                        ) :
                        (
                          <div styleName='main'>
                            <Loader
                              options={{scale: 0.70, top:'4.0rem'}}
                              loaded={ false }
                            />
                          </div>
                        )
                    }
                  </div>
                ) :
                null
            }
          </SlideDown>
        </div>
      </div>
    )
  }
}

